import aplicacionesBusint from '../data/aplicacionesBusint.json';

/**
 * Obtener el valor de una aplicación basándose en su ID
 * @param {number} lookupId - ID de la aplicación
 * @returns {string} Valor de la aplicación (ej: "busint_erp")
 */
export const getAplicacionValueById = (lookupId) => {
  const app = aplicacionesBusint.aplicaciones.find(a => a.id === lookupId);
  return app ? app.value : 'posint';
};

/**
 * Obtener el label de una aplicación basándose en su ID
 * @param {number} lookupId - ID de la aplicación
 * @returns {string} Label de la aplicación (ej: "Busint Erp")
 */
export const getAplicacionLabelById = (lookupId) => {
  const app = aplicacionesBusint.aplicaciones.find(a => a.id === lookupId);
  return app ? app.label : 'Posint';
};

/**
 * Obtener toda la información de una aplicación basándose en su ID
 * @param {number} lookupId - ID de la aplicación
 * @returns {Object} Objeto con toda la información de la aplicación
 */
export const getAplicacionById = (lookupId) => {
  return aplicacionesBusint.aplicaciones.find(a => a.id === lookupId) || aplicacionesBusint.aplicaciones[1];
};

/**
 * Obtener todas las aplicaciones
 * @returns {Array} Array de todas las aplicaciones
 */
export const getAllAplicaciones = () => {
  return aplicacionesBusint.aplicaciones;
};

/**
 * Obtener los labels de todas las aplicaciones en orden
 * @returns {Array} Array de labels
 */
export const getAplicacionLabels = () => {
  return aplicacionesBusint.aplicaciones.map(a => a.label);
};
